<template>
  <div>
    <Bj :bjData="bjData" />
    <div class="asTxt">
      <div class="tit">| 关于米啦 |</div>
      <div class="txt">
        米啦是一个以智慧教育为主体，以课程辅导为载体，在全球范围内服务公办教育，助力民办教育，
      </div>
      <div class="txt">探索未来教育新模式的科技教育公司。</div>
    </div>
    <div class="bodyBox">
      <div class="myTitle bgfb">让兴趣教育乘风破浪</div>
      <div class="miniTitle" style="background: #fbfbfb">兴趣让学习更高效</div>
      <div class="bgfb">
        <div class="phone">
          <img src="../../assets/pc/home/phone.png" alt="" />
          <div>
            <div class="phoneTxt">
              <div>精准学习导航</div>
              <div>基于10万+学员行为数据，AI算法动态推荐适配课程</div>
            </div>
            <div class="phoneTxt mg_top54">
              <div>沉浸式学习引擎</div>
              <div>实时追踪技能提升轨迹，薄弱点自动标记</div>
            </div>
          </div>
        </div>
      </div>
      <div class="myTitle">为什么选择米啦</div>
      <div class="miniTitle">专业团队精心打造，全方位助力学习</div>
      <div class="detailsBox">
        <div class="navList">
          <div
            class="item"
            @click="select(item, i)"
            v-for="(item, i) in navList"
            :key="i"
            :style="{
              'font-weight': i == navIndex ? 'bold' : '',
            }"
          >
            {{ item.title }}
            <div :class="i == navIndex ? 'index' : ''"></div>
          </div>
        </div>
        <img class="detailsImg" :src="require('@/' + detailsImg)" alt="" />
        <!-- <button class="btn" @click="goToWebsite">查看详情</button> -->
      </div>
      <!-- <div class="myTitle">日语高考学习方案</div>
			<div class="miniTitle">优秀的学习方案，让学习事半功倍</div>
			<MoveSquare />
			<button class="btn" @click="$router.push('/gaokao')">
				更多日语高考相关
			</button> -->
      <div class="myTitle bgfb">更多学员青睐的专业学习方案</div>
      <div class="miniTitle bgfb">看得见的严苛标准</div>
      <div class="learning_program_out bgfb">
        <div class="learning_program">
          <div class="learning_program_item" v-for="(item, i) in learningList" :key="i">
            <img class="learning_program_img" :src="require('@/' + item.imgUrl)" alt="" />
            <div class="learning_program_title">
              {{ item.title }}
            </div>
            <div class="learning_program_introduce">
              {{ item.introduce }}
            </div>
          </div>
        </div>
      </div>
      <!-- <Develop /> -->
    </div>
  </div>
</template>

<script>
// import MoveSquare from '@/components/pc/moveSquare.vue'
// import Develop from "@/components/pc/develop.vue";
import Bj from "@/components/pc/bj";
export default {
  components: {
    Bj,
    // MoveSquare,
    // Develop,
  },
  data() {
    return {
      bjData: {
        imgUrl: "https://qn.juquedu.com/home.png",
        title: "选择米啦",
        minTitle: "让学习更有趣",
      },
      navIndex: 0,
      navList: [
        {
          title: "用户第一",
          imgUrl: "assets/pc/home/introduceOne.png",
        },
        {
          title: "自主研发",
          imgUrl: "assets/pc/home/introduceTwo.png",
        },
        {
          title: "服务流程",
          imgUrl: "assets/pc/home/introduceThree.png",
        },
        // {
        //   title: "教学质量把控",
        //   imgUrl: "assets/pc/home/introduceFour.png",
        // },
        // {
        //   title: "品控把控",
        //   imgUrl: "assets/pc/home/introduceFive.png",
        // },
        // {
        //   title: "教研工作",
        //   imgUrl: "assets/pc/home/introduceSix.png",
        // },
      ],
      detailsImg: "assets/pc/home/introduceOne.png",
      learningList: [
        {
          imgUrl: "assets/pc/home/learning1.png",
          title: "严选精品课池",
          des: "",
          introduce: "每月引入 ​30+ 前沿新课\n淘汰末位 ​15% 旧课​",
        },
        {
          imgUrl: "assets/pc/home/learning2.png",
          title: "智能学习中枢",
          des: "",
          introduce: "行为分析引擎\n实时调优课表​",
        },
        {
          imgUrl: "assets/pc/home/learning3.png",
          title: "沉浸式掌握真技能",
          des: "",
          introduce: "手机观看，\n随看随学高清课程",
        },
        {
          imgUrl: "assets/pc/home/learning4.png",
          title: "兴趣共学",
          des: "",
          introduce: "高价值社交学习网络\n享受最新最优的课程",
        },
      ],
    };
  },
  methods: {
    select(item, i) {
      this.navIndex = i;
      this.detailsImg = item.imgUrl;
    },
    goToWebsite() {
      window.open("https://api.juquedu.com/website/index.html");
    },
  },
};
</script>

<style lang="scss" scoped>
.asTxt {
  height: 240px;
  width: 100%;
  min-width: 1200px;
  background-color: #ff293e;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .tit {
    font-size: 38px;
    margin-bottom: 20px;
  }
  .txt {
    margin-top: 10px;
  }
}
.bgfb {
  background: #fbfbfb;
}
.bodyBox {
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
  .btn {
    display: block;
    margin: 54px auto 0 auto;
    width: 188px;
    height: 68px;
    background: #ff293e;
    box-shadow: 0px 4px 10px rgba(255, 77, 94, 0.3);
    border-radius: 8px;
    color: #ffffff;
    font-size: 20px;
  }
  phone bgfb .btn:hover {
    cursor: pointer;
  }
  .btn:active {
    background: #750c16;
  }
  .detailsBox {
    height: 727px;
    .navList {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1200px;
      height: 68px;
      border-bottom: 1px solid #dde1e5;
      margin: 48px auto 0 auto;
      font-size: 24px;
      .item {
        cursor: pointer;
        .index {
          width: 32px;
          margin: auto;
          content: "";
          position: relative;
          top: 16px;
          display: block;
          height: 4px;
          text-align: center;
          background-color: #ff293e;
          border-radius: 2px;
          animation: fadeInLeft 0.3s ease 0.2s 1 both;
        }
      }
      .item:nth-child(2) {
        padding: 0 236px;
      }
    }
    .detailsImg {
      display: block;
      margin: 27px auto 0 auto;
      width: 1200px;
    }
  }
  .learning_program_out {
    height: 469px;
    .learning_program {
      width: 1200px;
      margin: 0 auto;
      height: 469px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .learning_program_item {
        width: 182px;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        .learning_program_img {
          width: 108px;
          height: 108px;
          margin-top: 64px;
        }
        .learning_program_title {
          padding: 60px 0 20px;
          font-weight: bold;
          font-size: 20px;
          color: #333333;
        }
        .learning_program_introduce {
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          white-space: pre-line; /*保留换行符*/
          text-align: center;
        }
      }
    }
  }
  .phone {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 638px;
    width: 1200px;
    margin: 0 auto;
    img {
      width: 517px;
    }
    .mg_top54 {
      margin-top: 54px;
    }
    .phoneTxt {
      letter-spacing: 2.5px;
      div:nth-child(1) {
        font-size: 28px;
        color: #333333;
        font-weight: bold;
        display: flex;
        align-items: center;
      }
      div:nth-child(1)::before {
        content: "";
        display: inline-block;
        width: 3px;
        height: 30px;
        background-color: #ff3838;
        margin-right: 16px;
      }
      div:nth-child(2) {
        margin-top: 14px;
        color: #5f6464;
      }
    }
  }
}
</style>
